import styled, { keyframes } from "styled-components";

// Keyframes for typing effect
const typing = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

// Keyframes for blinking cursor
const blink = keyframes`
  from, to {
    border-color: transparent;
  }
  50% {
    border-color: white;
  }
`;

export const StyledSplashScreen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.background};

  .logo {
    position: fixed;
    left: 30px;
    top: 30px;
    z-index: 9;
    width: 15%;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 5%;
    }
  }
`;

export const StyledBG = styled.img`
  height: 100vh;
  width: auto;
  object-fit: cover;
  opacity: 0.8;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    ${({ theme }) =>
      theme.themeMode === "dark" &&
      `
      display: none;
    `}
  }
`;

export const StyledTextIntro = styled.div`
  position: fixed;
  z-index: 9;

  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};

  p {
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    width: 0;
    animation: ${typing} 3s steps(20, end) forwards;
    animation-delay: 0s;
    text-align: center;
  }

  h3 {
    text-align: center;
    font-size: 28px;
    letter-spacing: -1;
    font-weight: 600;
    margin: 0;
    border-right: none;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    width: 0;
    animation: ${typing} 3s steps(20, end) forwards,
      ${blink} 0.75s step-end infinite;
    animation-delay: 3s;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    right: initial;
    left: initial;
    bottom: initial;
    h3 {
      font-size: 27px;
      letter-spacing: 1px;
    }
    p {
      font-size: 22px;

      letter-spacing: 2px;
    }
  }
`;
